<template>
  <v-card outlined>
    <v-card-title class="align-start">
      <span class="font-weight-semibold text-base">Statistiques</span>
    </v-card-title>
    <loader v-if="isLoading" />
    <v-card-text v-else>
      <v-row>
        <v-col cols="6" lg="2" md="4">
          <div class="d-flex">
            <v-avatar size="44" color="primary" rounded class="elevation-1">
              <v-icon dark color="white" size="30">
                {{ icons.mdiCurrencyEur }}
              </v-icon>
            </v-avatar>
            <div class="ms-3">
              <p class="text-xs mb-0">CA</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="text--primary text-xl font-weight-bold"
                    v-on="on"
                    v-bind="attrs"
                    >{{ ca.value }}</span
                  >
                </template>
                <span>{{ ca.raw }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
        <v-col cols="6" lg="2" md="4">
          <div class="d-flex">
            <v-avatar size="44" color="primary" rounded class="elevation-1">
              <v-icon dark color="white" size="30">
                {{ icons.mdiSpeedometer }}
              </v-icon>
            </v-avatar>
            <div class="ms-3">
              <p class="text-xs mb-0">RPM</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="text--primary text-xl font-weight-bold"
                    v-on="on"
                    v-bind="attrs"
                    >{{ rpm.value }}</span
                  >
                </template>
                <span>{{ rpm.raw }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
        <v-col cols="6" lg="2" md="4">
          <div class="d-flex">
            <v-avatar size="44" color="primary" rounded class="elevation-1">
              <v-icon dark color="white" size="30">
                {{ icons.mdiMonitorEye }}
              </v-icon>
            </v-avatar>
            <div class="ms-3">
              <p class="text-xs mb-0">Vues</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="text--primary text-xl font-weight-bold"
                    v-on="on"
                    v-bind="attrs"
                    >{{ views.value }}</span
                  >
                </template>
                <span>{{ views.raw }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
        <v-col cols="6" lg="2" md="4">
          <div class="d-flex">
            <v-avatar size="44" color="primary" rounded class="elevation-1">
              <v-icon dark color="white" size="30">
                {{ icons.mdiFormatRotate90 }}
              </v-icon>
            </v-avatar>
            <div class="ms-3">
              <p class="text-xs mb-0">Sessions</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="text--primary text-xl font-weight-bold"
                    v-on="on"
                    v-bind="attrs"
                    >{{ sessions.value }}</span
                  >
                </template>
                <span>{{ sessions.raw }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
        <v-col cols="6" lg="2" md="4">
          <div class="d-flex">
            <v-avatar size="44" color="primary" rounded class="elevation-1">
              <v-icon dark color="white" size="30">
                {{ icons.mdiMonitorCellphone }}
              </v-icon>
            </v-avatar>
            <div class="ms-3">
              <p class="text-xs mb-0">Vues / Sessions</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="text--primary text-xl font-weight-bold"
                    v-on="on"
                    v-bind="attrs"
                    >{{ viewsPerSessions.value }}</span
                  >
                </template>
                <span>{{ viewsPerSessions.raw }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  mdiSpeedometer,
  mdiMonitorCellphone,
  mdiMonitorEye,
  mdiCurrencyEur,
  mdiFormatRotate90,
} from "@mdi/js";
import { formatNumberCompact, formatCurrencyCompact } from "@/utils/formatting";

import Loader from "@/components/common/Loader";

export default {
  name: "TopStatsCard",
  components: {
    Loader,
  },
  data() {
    return {
      isLoading: false,
      icons: {
        mdiSpeedometer,
        mdiMonitorCellphone,
        mdiMonitorEye,
        mdiCurrencyEur,
        mdiFormatRotate90,
      },
      ca: {
        value: 0,
        raw: 0,
      },
      views: {
        value: 0,
        raw: 0,
      },
      sessions: {
        value: 0,
        raw: 0,
      },
      rpm: {
        value: 0,
        raw: 0,
      },
      viewsPerSessions: {
        value: 0,
        raw: 0,
      },
    };
  },
  computed: {
    statsForPeriod() {
      return this.$store.getters["audience/getStatsForPeriod"];
    },
  },
  watch: {
    statsForPeriod() {
      this.isLoading = Object.keys(this.statsForPeriod).length === 0;
      if (this.isLoading) {
        return;
      }

      this.ca.raw = this.statsForPeriod.ca;
      this.ca.value = formatCurrencyCompact(this.ca.raw);

      this.views.raw = this.statsForPeriod.views;
      this.views.value = formatNumberCompact(this.views.raw);

      this.sessions.raw = this.statsForPeriod.sessions;
      this.sessions.value = formatNumberCompact(this.sessions.raw);

      this.rpm.raw = (this.ca.raw / this.sessions.raw) * 1000;
      this.rpm.value = `${this.rpm.raw.toFixed(2)}€`;
      this.viewsPerSessions.raw = this.views.raw / this.sessions.raw;
      this.viewsPerSessions.value = this.viewsPerSessions.raw.toFixed(2);
    },
  },
};
</script>

<style scoped></style>
